import commonApi from "./commonApi";
import serverurl, { serverUrl2 } from "./serverUrl";




export const verifyToken = async (data) => {
  try {
    const response = await commonApi("POST", `${serverurl}/token/verify/`, data);
    return response;
  } catch (error) {
    console.error("Error creating new course Program:", error.message);
    return { error: true, message: error.message };
  }
};

// New GET API: Fetch Common Utils Data
export const getCommonUtilsApi = async () => {
  try {
    const response = await commonApi("GET", `${serverurl}/common-utils/`, "");
    return response;
  } catch (error) {
    console.error("Error fetching common-utils:", error.message);
    return { error: true, message: error.message };
  }
};

// New PATCH API: Update Common Utils Data
export const updateCommonUtilsApi = async (commonutils_id, data) => {
  try {
    const response = await commonApi("PATCH", `${serverurl}/common-utils/${commonutils_id}/`, data);
    return response;
  } catch (error) {
    console.error("Error updating common-utils:", error.message);
    return { error: true, message: error.message };
  }
};


// New GET API: Fetch Batch Data
export const getBatchDataApi = async () => {
  try {
    const response = await commonApi("GET", `${serverurl}/new-batch/`, "");
    return response;
  } catch (error) {
    console.error("Error fetching batch data:", error.message);
    return { error: true, message: error.message };
  }
};

// New PATCH API: Update Batch Data
export const updateBatchApi = async (batchId, data) => {
  try {
    const response = await commonApi("PATCH", `${serverurl}/new-batch/${batchId}/`, data);
    return response;
  } catch (error) {
    console.error("Error updating batch data:", error.message);
    return { error: true, message: error.message };
  }
};

// New GET API: Fetch Advertisement Data
export const getAdvertisementDataApi = async () => {
  try {
    const response = await commonApi("GET", `${serverurl}/advertisement/`, "");
    return response;
  } catch (error) {
    console.error("Error fetching advertisement data:", error.message);
    return { error: true, message: error.message };
  }
};

// New PATCH API: Edit Advertisement Data
export const editAdvertisementApi = async (advertisementId, data) => {
  try {
    const response = await commonApi("PATCH", `${serverurl}/advertisement/${advertisementId}/`, data);
    return response;
  } catch (error) {
    console.error("Error updating advertisement data:", error.message);
    return { error: true, message: error.message };
  }
};

// New POST API: Create New Advertisement
export const addAdvertisementApi = async (data) => {
  console.log("API request initiated", data); // Log the data
  try {
    const response = await commonApi("POST", `${serverurl}/advertisement/`, data);
    return response;
  } catch (error) {
    console.error("Error creating new advertisement:", error.message);
    return { error: true, message: error.message };
  }
};

// New DELETE API: Delete Advertisement Data
export const deleteAdvertisementApi = async (advertisementId) => {
  try {
    const response = await commonApi("DELETE", `${serverurl}/advertisement/${advertisementId}/`, "");
    return response;
  } catch (error) {
    console.error("Error deleting advertisement:", error.message);
    return { error: true, message: error.message };
  }
};


// New GET API: Fetch Active Advertisement
export const toggleAdvertisementStatusApi = async (advertisementId) => {
  try {
    const response = await commonApi("GET", `${serverurl}/change-advertisement/${advertisementId}/`, "");
    return response;
  } catch (error) {
    console.error("Error fetching advertisement data by ID:", error.message);
    return { error: true, message: error.message };
  }
};

// New GET API: Fetch Courses Data
export const getCoursesApi = async () => {
  try {
    const response = await commonApi("GET", `${serverurl}/courses/`, "");
    return response;
  } catch (error) {
    console.error("Error fetching courses data:", error.message);
    return { error: true, message: error.message };
  }
};

// New GET API: Fetch Course SEO Metadata by ID
export const getCourseSeoMetadataApi = async (courseId) => {
  try {
    const response = await commonApi("GET", `${serverurl}/courses-seometadata/${courseId}/`, "");
    return response;
  } catch (error) {
    console.error("Error fetching course SEO metadata:", error.message);
    return { error: true, message: error.message };
  }
};

// New PATCH API: Update Course SEO Metadata
export const updateCourseSeoMetadataApi = async (courseId, data) => {
  try {
    const headers = {
      "Content-type" : "multipart/form-data"
    }
    const response = await commonApi("PATCH", `${serverurl}/courses-seometadata-update/${courseId}/`, data,headers);
    return response;
  } catch (error) {
    console.error("Error updating course SEO metadata:", error.message);
    return { error: true, message: error.message };
  }
};


// New GET API: Fetch CourseModules Data
export const getCourseModulestDataApi = async (courseId) => {
  try {
    const response = await commonApi("GET", `${serverurl}/course-modules/${courseId}/`, "");
    return response;
  } catch (error) {
    console.error("Error fetching coursemodules data:", error.message);
    return { error: true, message: error.message };
  }
};

// New POST API: Create New Course Module
export const addCourseModuleApi = async (data) => {
  try {
    const response = await commonApi("POST", `${serverurl}/course-modules/`, data);
    return response;
  } catch (error) {
    console.error("Error creating new course module:", error.message);
    return { error: true, message: error.message };
  }
};

// New DELETE API: Delete Course Module
export const deleteCourseModuleApi = async (moduleId) => {
  try {
    const response = await commonApi("DELETE", `${serverurl}/course-modules-detail/${moduleId}/`, "");
    return response;
  } catch (error) {
    console.error("Error deleting course module:", error.message);
    return { error: true, message: error.message };
  }
};

// PATCH API: Update Course Module
export const updateCourseModuleApi = async (moduleId, updatedData) => {
  try {
    const response = await commonApi("PATCH", `${serverurl}/course-modules-detail/${moduleId}/`, updatedData);
    return response;
  } catch (error) {
    console.error("Error updating course module:", error.message);
    return { error: true, message: error.message };
  }
};

// New GET API: Fetch CourseProgram Data
export const getCourseProgramtDataApi = async (courseId) => {
  try {
    const response = await commonApi("GET", `${serverurl}/course-program/${courseId}/`, "");
    return response;
  } catch (error) {
    console.error("Error fetching course program data:", error.message);
    return { error: true, message: error.message };
  }
};

// New POST API: Create New Course Program
export const addCourseProgramApi = async (data) => {
  try {
    const response = await commonApi("POST", `${serverurl}/course-program/`, data);
    return response;
  } catch (error) {
    console.error("Error creating new course Program:", error.message);
    return { error: true, message: error.message };
  }
};

// New DELETE API: Delete Course Program
export const deleteCourseProgramApi = async (programId) => {
  try {
    const response = await commonApi("DELETE", `${serverurl}/course-program-detail/${programId}/`, "");
    return response;
  } catch (error) {
    console.error("Error deleting course module:", error.message);
    return { error: true, message: error.message };
  }
};


// New GET API: Fetch CourseSupportData
export const getSupportDataApi = async (courseId) => {
  try {
    const response = await commonApi("GET", `${serverurl}/course-support/${courseId}/`, "");
    return response;
  } catch (error) {
    console.error("Error fetching course program data:", error.message);
    return { error: true, message: error.message };
  }
};

// New POST API: Create New Course Support
export const addSupportDataApi = async (data) => {
  try {
    const response = await commonApi("POST", `${serverurl}/course-support/`, data);
    return response;
  } catch (error) {
    console.error("Error creating new course Program:", error.message);
    return { error: true, message: error.message };
  }
};

// New DELETE API: Delete Course support
export const deleteSupportDataApi = async (programId) => {
  try {
    const response = await commonApi("DELETE", `${serverurl}/course-support-detail/${programId}/`, "");
    return response;
  } catch (error) {
    console.error("Error deleting course module:", error.message);
    return { error: true, message: error.message };
  }
};

//  New GET API: Fetch CourseSection1 Data
export const getCourseSection1DataApi = async (courseId) => {
  try {
    const response = await commonApi("GET", `${serverurl}/course-points-section1/${courseId}/`, "");
    return response;
  } catch (error) {
    console.error("Error fetching course program data:", error.message);
    return { error: true, message: error.message };
  }
};

// New POST API: Create New Course Section1
export const addCourseSection1DataApi = async (data) => {
  try {
    const response = await commonApi("POST", `${serverurl}/course-points-section1/`, data);
    return response;
  } catch (error) {
    console.error("Error creating new course Program:", error.message);
    return { error: true, message: error.message };
  }
};

// New DELETE API: Delete Course setion 1
export const deleteCourseSection1DataApi = async (programId) => {
  try {
    const response = await commonApi("DELETE", `${serverurl}/course-points-section1-detail/${programId}/`, "");
    return response;
  } catch (error) {
    console.error("Error deleting course module:", error.message);
    return { error: true, message: error.message };
  }
};
 

//  New GET API: Fetch CourseSection2 Data
export const getCourseSection2DataApi = async (courseId) => {
  try {
    const response = await commonApi("GET", `${serverurl}/course-points-section2/${courseId}/`, "");
    return response;
  } catch (error) {
    console.error("Error fetching course program data:", error.message);
    return { error: true, message: error.message };
  }
};

// New POST API: Create New Course Section2
export const addCourseSection2DataApi = async (data) => {
  try {
    const response = await commonApi("POST", `${serverurl}/course-points-section2/`, data);
    return response;
  } catch (error) {
    console.error("Error creating new course Program:", error.message);
    return { error: true, message: error.message };
  }
};

// New DELETE API: Delete Course setion 2
export const deleteCourseSection2DataApi = async (programId) => {
  try {
    const response = await commonApi("DELETE", `${serverurl}/course-points-section2-detail/${programId}/`, "");
    return response;
  } catch (error) {
    console.error("Error deleting course module:", error.message);
    return { error: true, message: error.message };
  }
};



// New GET API: Fetch Trainers Data
export const getTrainerDataApi = async () => {
  try {
    const response = await commonApi("GET", `${serverurl}/trainers/`, "");
    return response;
  } catch (error) {
    console.error("Error fetching trainers data:", error.message);
    return { error: true, message: error.message };
  }
};

// New PATCH API: Edit Trainer Data
export const updateTrainerApi = async (id, data) => {
  try {
    const response = await commonApi("PATCH", `${serverurl}/trainers/${id}/`, data);
    return response;
  } catch (error) {
    console.error("Error updating trainer data:", error.message);
    return { error: true, message: error.message };
  }
};

// New POST API: Create New Trainer
export const addTrainerApi = async (data) => {
  console.log("API request initiated", data); // Log the data
  try {
    const response = await commonApi("POST", `${serverurl}/trainers/`, data);
    return response;
  } catch (error) {
    console.error("Error creating new trainer:", error.message);
    return { error: true, message: error.message };
  }
};

// New DELETE API: Delete Trainer Data
export const deleteTrainerApi = async (id) => {
  try {
    const response = await commonApi("DELETE", `${serverurl}/trainers/${id}/`, "");
    return response;
  } catch (error) {
    console.error("Error deleting trainer:", error.message);
    return { error: true, message: error.message };
  }
};

// New GET API: Fetch Active trainer
export const toggleTrainerStatusApi = async (trainerId) => {
  try {
    const response = await commonApi("GET", `${serverurl}/change-trainers/${trainerId}/`, "");
    return response;
  } catch (error) {
    console.error("Error fetching trainer data by ID:", error.message);
    return { error: true, message: error.message };
  }
};


//Homepage details
export const homePageDetailsApi = async () => {
  try {
    const response = await commonApi("GET", `${serverurl}/seo-metadata/homepage/`, "");
    return response;
  } catch (error) {
    console.error("Error fetching homepage data:", error.message);
    return { error: true, message: error.message };
  }
};

//home-content-api
export const homeContentApi = async () => {
  try {
    const response = await commonApi("GET", `${serverurl}/home-content/`, "");
    return response;
  } catch (error) {
    console.error("Error fetching Home content data:", error.message);
    return { error: true, message: error.message };
  }
};


//Who we are api
export const whoWeAreApi = async () => {
  try {
    const response = await commonApi("GET", `${serverurl}/who-we-are/`, "");
    return response;
  } catch (error) {
    console.error("Error fetching who we are data:", error.message);
    return { error: true, message: error.message };
  }
};


//home page details edit api
export const homePageDetailsEditApi = async (identifier, formData) => {
  try {
    console.log("sending data",formData);
    
    const response = await commonApi("PATCH",`${serverurl}/seo-metadata/${identifier}/`, formData);
    console.log( "response from backend",response.data);
    return response.data; 
  } catch (error) {
    console.error("Error updating homepage details:", error);
    throw error; 
  }
};


//home content details edit api
export const EditHomeContentApi = async (id, formData) => {
  try {
    console.log("sending data",formData);
    
    const response = await commonApi("PATCH",`${serverurl}/home-content/${id}/`, formData);
    console.log( "response from backend",response.data);
    return response.data; 
  } catch (error) {
    console.error("Error updating homecontent details:", error);
    throw error; 
  }
};


//who we are details edit api
export const EditWhoWeAreApi = async (id, formData) => {
  try {
    console.log("sending data",formData);
    
    const response = await commonApi("PATCH",`${serverurl}/who-we-are/${id}/`, formData);
    console.log( "response from backend",response.data);
    return response.data; 
  } catch (error) {
    console.error("Error updating who we are details:", error);
    throw error; 
  }
};


// New GET API: fetching become a trainer data
export const getBecomeAtrainerDetailsapi = async (page = 1) => {
  try {
  
    const response = await commonApi("GET", `${serverUrl2}/become-a-trainer/?page=${page}`);
    return response; // Ensure the API response is returned correctly
  } catch (error) {
    console.error('Error fetching trainer details:', error.message);
    throw error; // Propagate the error
  }
};


// New GET API: fetching hirefromus data
export const getHireDetailsApi  = async (page = 1) => {
  try {
    const headers = {
      "Content-Type" : "application/json"
    }
    const response = await commonApi("GET", `${serverUrl2}/hire-requests/?page=${page}`,headers);
    return response; // Ensure the API response is returned correctly
  } catch (error) {
    console.error('Error fetching hirefromus details:', error.message);
    throw error; // Propagate the error
  }
};





// New GET API: fetching Contact us data
export const getContactUsDetailsapi = async (page = 1) => {
  try {
  
    const response = await commonApi("GET", `${serverUrl2}/contact-us-data/?page=${page}`);
    return response; // Ensure the API response is returned correctly
  } catch (error) {
    console.error('Error fetching Contact us details:', error.message);
    throw error; // Propagate the error
  }
};


// New GET API: fetching brochure-request us data
export const getBrochurerSubmitapi = async (page = 1) => {
  try {
  
    const response = await commonApi("GET", `${serverUrl2}/brochure-request/?page=${page}`);
    return response; // Ensure the API response is returned correctly
  } catch (error) {
    console.error('Error fetching brochure-request details:', error.message);
    throw error; // Propagate the error
  }
};

// New GET API: fetching book-callback us data
export const getBookCallbackapi = async (page = 1) => {
  try {
  
    const response = await commonApi("GET", `${serverUrl2}/book-callback/?page=${page}`);
    return response; // Ensure the API response is returned correctly
  } catch (error) {
    console.error('Error fetching book-callback details:', error.message);
    throw error; // Propagate the error
  }
};

// Corrected sign-in API call
export const signInapi = async (adminData) => {
  try {
    // Make the POST request with username and password in the body
    const response = await commonApi("POST", `${serverurl}/admin-login/`, adminData);
    return response; // Ensure the API response is returned correctly
  } catch (error) {
    console.error('Error fetching Sign-in details:', error.message);
    throw error; // Propagate the error
  }
};




// geting hireing partners image
export const gtetHiringPartners = async () => {
  try {
  
    const response = await commonApi("GET", `${serverurl}/hiring-partners/`);
    return response; // Ensure the API response is returned correctly
  } catch (error) {
    console.error('Error fetching hiring partners:', error.message);
    throw error; // Propagate the error
  }
};


// add hireing partners image
export const AddHiringPartners = async (image) => {
  try {
  
    const response = await commonApi("POST", `${serverurl}/hiring-partners/`,image);
    return response; // Ensure the API response is returned correctly
  } catch (error) {
    console.error('Error adding hiring partners:', error.message);
    throw error; // Propagate the error
  }
};



// DELETE hireing partners image
export const deleteHiringPartners = async (id) => {
  try {
  
    const response = await commonApi("DELETE", `${serverurl}/hiring-partners/${id}/`,);
    return response; // Ensure the API response is returned correctly
  } catch (error) {
    console.error('Error deleting hiring partners:', error.message);
    throw error; // Propagate the error
  }
};

//home page botton data fetching
export const homePageBottomApi = async () => {
  try {
    const response = await commonApi("GET", `${serverUrl2}/home-page-bottom-card/`, "");
    return response;
  } catch (error) {
    console.error("Error fetching Home page bottom data:", error.message);
    return { error: true, message: error.message };
  }
};


//home-page-bottom-edit
export const edithomePageBottomApi = async (id,formData) => {
  try {
    const response = await commonApi("PATCH", `${serverUrl2}/home-page-bottom-card/${id}/`, formData);
    return response;
  } catch (error) {
    console.error("Error editig Home button content data:", error.message);
    return { error: true, message: error.message };
  }
};



//course list
export const getCoursePageList = async () => {
  try {
    const response = await commonApi("GET", `${serverurl}/course-list/`, "");
    return response;
  } catch (error) {
    console.error("Error fetching Course list page data:", error.message);
    return { error: true, message: error.message };
  }
};



//Couse page list
export const editCoursePageList = async (id,formData) => {
  try {
    const response = await commonApi("PATCH", `${serverurl}/course-list/${id}/`, formData);
    return response;
  } catch (error) {
    console.error("Error editig course list page data:", error.message);
    return { error: true, message: error.message };
  }
};



//Placement Api settings
export const getPlacementPage = async () => {
  try {
    const response = await commonApi("GET", `${serverUrl2}/placement-page/`, "");
    return response;
  } catch (error) {
    console.error("Error fetching placemant page data:", error.message);
    return { error: true, message: error.message };
  }
};


//edit placement page
export const editPlacementPage = async (id,formDataToSend) => {
  try {
    console.log("sending data",formDataToSend);
    
    const response = await commonApi("PATCH", `${serverUrl2}/placement-page/${id}/`, formDataToSend);
    return response;
  } catch (error) {
    console.error("Error editig placement page page data:", error.message);
    return { error: true, message: error.message };
  }
};


export const courseSeoPageApi = async () => {
  try {
    const response = await commonApi("GET", `${serverurl}/seo-metadata/course_list/`, "");
    return response;
  } catch (error) {
    console.error("Error fetching homepage data:", error.message);
    return { error: true, message: error.message };
  }
};


export const editCourseSeoApi = async (identifier, formData) => {
  try {
    console.log("sending data",formData);
    
    const response = await commonApi("PATCH",`${serverurl}/seo-metadata/${identifier}/`, formData);
    console.log( "response from backend",response.data);
    return response.data; 
  } catch (error) {
    console.error("Error updating homepage details:", error);
    throw error; 
  }
};


export const placemantSeoPageApi = async () => {
  try {
    const response = await commonApi("GET", `${serverurl}/seo-metadata/placement/`, "");
    return response;
  } catch (error) {
    console.error("Error fetching homepage data:", error.message);
    return { error: true, message: error.message };
  }
};


export const editPlacementSeoApi = async (identifier, formData) => {
  try {
    console.log("sending data",formData);
    
    const response = await commonApi("PATCH",`${serverurl}/seo-metadata/${identifier}/`, formData);
    console.log( "response from backend",response.data);
    return response.data; 
  } catch (error) {
    console.error("Error updating homepage details:", error);
    throw error; 
  }
};



//adding trainer
export const addTrainerstDataApi = async (formData) => {
  try {
    const response = await commonApi("POST", `${serverurl}/trainers/`, formData);
    return response;
  } catch (error) {
    console.error("Error in adding trainer data:", error.message);
    return { error: true, message: error.message };
  }
};

//editing trainer
export const editTrainerstDataApi = async (id,formData) => {
  try {
    const response = await commonApi("PATCH", `${serverurl}/trainers/${id}/`, formData);
    return response;
  } catch (error) {
    console.error("Error in editing trainer data:", error.message);
    return { error: true, message: error.message };
  }
};

//delete trainer
export const deleteTrainerstDataApi = async (id) => {
  try {
    const response = await commonApi("DELETE", `${serverurl}/trainers/${id}/`,"");
    return response;
  } catch (error) {
    console.error("Error in DELETING trainer data:", error.message);
    return { error: true, message: error.message };
  }
};
//delete trainer
export const trainerToggleApi = async (id) => {
  try {
    const response = await commonApi("GET", `${serverurl}/trainers-display/${id}/`,"");
    return response;
  } catch (error) {
    console.error("Error in status trainer data:", error.message);
    return { error: true, message: error.message };
  }
};



//about details
export const aboutUsDetailsApi = async () => {
  try {
    const response = await commonApi("GET", `${serverurl}/seo-metadata/about/`, "");
    return response;
  } catch (error) {
    console.error("Error fetching about data:", error.message);
    return { error: true, message: error.message };
  }
};

//home page details edit api
export const aboutDetailsEditApi = async (identifier, formData) => {
  try {
    console.log("sending data",formData);
    
    const response = await commonApi("PATCH",`${serverurl}/seo-metadata/${identifier}/`, formData);
    console.log( "response from backend",response.data);
    return response.data; 
  } catch (error) {
    console.error("Error updating about details:", error);
    throw error; 
  }
};


//about-content-api
export const aboutContentApi = async () => {
  try {
    const response = await commonApi("GET", `${serverUrl2}/about-us/`, "");
    return response;
  } catch (error) {
    console.error("Error fetching about content data:", error.message);
    return { error: true, message: error.message };
  }
};

//about content details edit api
export const EditAboutContentApi = async (id, formData) => {
  try {
    console.log("sending data",formData);
    
    const response = await commonApi("PATCH",`${serverUrl2}/about-us/${id}/`, formData);
    console.log( "response from backend",response);
    return response; 
  } catch (error) {
    console.error("Error updating about details:", error);
    throw error; 
  }
};

//whyLuminar data fetching
export const whyLuminarApi = async () => {
  try {
    const response = await commonApi("GET", `${serverUrl2}/why-luminar/`, "");
    return response;
  } catch (error) {
    console.error("Error fetching whyLuminar data:", error.message);
    return { error: true, message: error.message };
  }
};


//whyLuminar Edit
export const editWhyLuminarApi = async (id,formData) => {
  try {
    const response = await commonApi("PATCH", `${serverUrl2}/why-luminar/${id}/`, formData);
    return response;
  } catch (error) {
    console.error("Error editig whyLuminar data:", error.message);
    return { error: true, message: error.message };
  }
};


//CeoMessageApi
export const CeoMessageApi = async () => {
  try {
    const response = await commonApi("GET", `${serverUrl2}/ceo-message/`, "");
    return response;
  } catch (error) {
    console.error("Error fetching ceo-message content data:", error.message);
    return { error: true, message: error.message };
  }
};

//about content details edit api
export const EditCeoMessageApi = async (id, formData) => {
  try {
    console.log("sending data",formData);
    
    const response = await commonApi("PATCH",`${serverUrl2}/ceo-message/${id}/`, formData);
    console.log( "response from backend",response);
    return response; 
  } catch (error) {
    console.error("Error updating about details:", error);
    throw error; 
  }
};

//MissionVision data fetching
export const MissionVisionApi = async () => {
  try {
    const response = await commonApi("GET", `${serverUrl2}/mission-and-vision/`, "");
    return response;
  } catch (error) {
    console.error("Error fetching MissionVision data:", error.message);
    return { error: true, message: error.message };
  }
};


//home-page-bottom-edit
export const editMissionVisionApi = async (id,formData) => {
  try {
    const response = await commonApi("PATCH", `${serverUrl2}/mission-and-vision/${id}/`, formData);
    return response;
  } catch (error) {
    console.error("Error editig MissionVision content data:", error.message);
    return { error: true, message: error.message };
  }
};

//get Tag List
export const getListTag = async () => {
  try {
    const response = await commonApi("GET", `${serverurl}/tags/`);
    return response;
  } catch (error) {
    console.error("Error fetching Data:", error.message);
    return { error: true, message: error.message };
  }
};



//get placement-image List
export const getPlacementImage = async () => {
  try {
    const response = await commonApi("GET", `${serverUrl2}/placement-image/`,'');
    return response;
  } catch (error) {
    console.error("Error fetching Data:", error.message);
    return { error: true, message: error.message };
  }
};

//add placement-image List
export const addPlacementImage = async (formData) => {
  try {
    const response = await commonApi("POST", `${serverUrl2}/placement-image/`,formData);
    return response;
  } catch (error) {
    console.error("Error in adding placment image Data:", error.message);
    return { error: true, message: error.message };
  }
};


//delete placement-image 
export const deletePlacementImage = async (id) => {
  try {
    const response = await commonApi("DELETE", `${serverUrl2}/placement-image/${id}/`,'');
    return response;
  } catch (error) {
    console.error("Error in deleting placment image Data:", error.message);
    return { error: true, message: error.message };
  }
};


//Update placement-image 
export const updatePlacementImage = async (id,formData) => {
  try {
    const response = await commonApi("PATCH", `${serverUrl2}/placement-image/${id}/`,formData);
    return response;
  } catch (error) {
    console.error("Error in deleting placment image Data:", error.message);
    return { error: true, message: error.message };
  }
};


//get locations 
export const getLocation = async () => {
  try {
    const response = await commonApi("GET", `${serverurl}/location/`,'');
    return response;
  } catch (error) {
    console.error("Error in fetching loaction Data:", error.message);
    return { error: true, message: error.message };
  }
};

//add locations 
export const addLocation = async (formData) => {
  try {
    const response = await commonApi("POST", `${serverurl}/location/`,formData);
    return response;
  } catch (error) {
    console.error("Error in adding loaction Data:", error.message);
    return { error: true, message: error.message };
  }
};

//delete locations
export const deleteLocation = async(id)=>{
  try{
    const response=await commonApi('DELETE',`${serverurl}/location/${id}/`)
    return response
  }
  catch(error){
    console.log("Error in deleting location data",error.message);
    return {error:true,message:error.message}
    
  }
}


//patch locations
export const editLocation = async(id,formData)=>{
  try{
    const response=await commonApi('PATCH',`${serverurl}/location/${id}/`,formData)
    return response
  }
  catch(error){
    console.log("Error in editing location data",error.message);
    return {error:true,message:error.message}
    
  }
}


//get gallery main images
export const getGalleryMainImages = async()=>{
  try{
    const response=await commonApi('GET',`${serverUrl2}/gallery-main-image/`,'')
    return response
  }
  catch(error){
    console.log("Error in fetchin gallary main images data",error.message);
    return {error:true,message:error.message}
    
  }
}


//add gallery main images
export const addGalleryMainImages = async(formData)=>{
  try{
    const response=await commonApi('POST',`${serverUrl2}/gallery-main-image/`,formData)
    return response
  }
  catch(error){
    console.log("Error in adding gallary main images data",error.message);
    return {error:true,message:error.message}
    
  }
}


//delete gallery main images
export const deleteGalleryMainImages = async(id)=>{
  try{
    const response=await commonApi('DELETE',`${serverUrl2}/gallery-main-image/${id}/`,'')
    return response
  }
  catch(error){
    console.log("Error in deleting gallary main images data",error.message);
    return {error:true,message:error.message}
    
  }
}

//edit gallery main images
export const updateGalleryMainImages = async(id,formData)=>{
  try{
    const response=await commonApi('PATCH',`${serverUrl2}/gallery-main-image/${id}/`,formData)
    return response
  }
  catch(error){
    console.log("Error in editing gallary main images data",error.message);
    return {error:true,message:error.message}
    
  }
}


//get gallery sub images
export const getGallerySubImages = async()=>{
  try{
    const response=await commonApi('GET',`${serverUrl2}/gallery-sub-image/`,'')
    return response
  }
  catch(error){
    console.log("Error in fetchin gallary main images data",error.message);
    return {error:true,message:error.message}
    
  }
}


//add gallery main images
export const addGallerySubImages = async(formData)=>{
  try{
    const response=await commonApi('POST',`${serverUrl2}/gallery-sub-image/`,formData)
    return response
  }
  catch(error){
    console.log("Error in adding gallary sub images data",error.message);
    return {error:true,message:error.message}
    
  }
}


//delete gallery main images
export const deleteGallerySubImages = async(id)=>{
  try{
    const response=await commonApi('DELETE',`${serverUrl2}/gallery-sub-image/${id}/`,'')
    return response
  }
  catch(error){
    console.log("Error in deleting gallary sub images data",error.message);
    return {error:true,message:error.message}
    
  }
}


//edit gallery main images
export const updateGallerySubImages = async(id,formData)=>{
  try{
    const response=await commonApi('PATCH',`${serverUrl2}/gallery-sub-image/${id}/`,formData)
    return response
  }
  catch(error){
    console.log("Error in editing gallary sub images data",error.message);
    return {error:true,message:error.message}
    
  }
}



//TrainerPage details
export const TrainerPageDetailsApi = async () => {
  try {
    const response = await commonApi("GET", `${serverurl}/seo-metadata/trainers/`, "");
    return response;
  } catch (error) {
    console.error("Error fetching TrainerPage data:", error.message);
    return { error: true, message: error.message };
  }
};

//TrainerPage details edit api
export const TrainerPageEditApi = async (identifier, formData) => {
  try {
    console.log("sending data",formData);
    
    const response = await commonApi("PATCH",`${serverurl}/seo-metadata/${identifier}/`, formData);
    console.log( "response from backend",response.data);
    return response.data; 
  } catch (error) {
    console.error("Error updating TrainerPage details:", error);
    throw error; 
  }
};


//TrainerContentApi
export const TrainerContentApi = async () => {
  try {
    const response = await commonApi("GET", `${serverUrl2}/trainers-page/`, "");
    return response;
  } catch (error) {
    console.error("Error fetching TrainerContentApi content data:", error.message);
    return { error: true, message: error.message };
  }
};

//trainers-page content details edit api
export const EditTrainerContentApi = async (id, formData) => {
  try {
    console.log("sending data",formData);
    
    const response = await commonApi("PATCH",`${serverUrl2}/trainers-page/${id}/`, formData);
    console.log( "response from backend",response);
    return response; 
  } catch (error) {
    console.error("Error updating TrainerContent details:", error);
    throw error; 
  }
};


//TesimonialPage details
export const TesimonialPageDetailsApi = async () => {
  try {
    const response = await commonApi("GET", `${serverurl}/seo-metadata/testimonial/`, "");
    return response;
  } catch (error) {
    console.error("Error fetching TesimonialPage data:", error.message);
    return { error: true, message: error.message };
  }
};

//testimonial details edit api
export const TesimonialPageEditApi = async (identifier, formData) => {
  try {
    console.log("sending data",formData);
    
    const response = await commonApi("PATCH",`${serverurl}/seo-metadata/${identifier}/`, formData);
    console.log( "response from backend",response.data);
    return response.data; 
  } catch (error) {
    console.error("Error updating TesimonialPage details:", error);
    throw error; 
  }
};

//TestimonialContentApi
export const TestimonialContentApi = async () => {
  try {
    const response = await commonApi("GET", `${serverUrl2}/testimonial-page/`, "");
    return response;
  } catch (error) {
    console.error("Error fetching TestimonialContent content data:", error.message);
    return { error: true, message: error.message };
  }
};

//testimonial-page content details edit api
export const EditTestimonialContentApi = async (id, formData) => {
  try {
    console.log("sending data",formData);
    
    const response = await commonApi("PATCH",`${serverUrl2}/testimonial-page/${id}/`, formData);
    console.log( "response from backend",response);
    return response; 
  } catch (error) {
    console.error("Error updating TestimonialContent details:", error);
    throw error; 
  }
};



// New GET API: fetching useful link data
export const getUsefulLinkDetailsapi = async () => {
  try {
  
    const response = await commonApi("GET", `${serverUrl2}/useful-link/`);
    return response; // Ensure the API response is returned correctly
  } catch (error) {
    console.error('Error fetching useful link details:', error.message);
    throw error; // Propagate the error
  }
};

//edit usefullink page
export const editUsefulLinkPage = async (id,formDataToSend) => {
  try {
    console.log("sending data",formDataToSend);
    
    const response = await commonApi("PATCH", `${serverUrl2}/useful-link/${id}/`, formDataToSend);
    return response;
  } catch (error) {
    console.error("Error editig usefullink page data:", error.message);
    return { error: true, message: error.message };
  }
};


// post usefullink page
export const addUsefulLinkApi = async (data) => {
  console.log("API request initiated", data); // Log the data
  try {
    const response = await commonApi("POST", `${serverUrl2}/useful-link/`, data);
    return response;
  } catch (error) {
    console.error("Error creating new usefullink:", error.message);
    return { error: true, message: error.message };
  }
};


// New DELETE API: Delete UsefulLink Data
export const deleteUsefulLinkApi = async (id) => {
  try {
    const response = await commonApi("DELETE", `${serverUrl2}/useful-link/${id}/`, "");
    return response;
  } catch (error) {
    console.error("Error deleting UsefulLink:", error.message);
    return { error: true, message: error.message };
  }
};

// New GET API: fetching job posting data
export const getJobsApi = async () => {
  try {
    const response = await commonApi("GET", `${serverUrl2}/job-posting/`, "");
    return response;
  } catch (error) {
    console.error("Error fetching job-post data:", error.message);
    return { error: true, message: error.message };
  }
};


// New POST API: Create New job post 
export const addJobApi = async (data) => {
  try {
    const response = await commonApi("POST", `${serverUrl2}/job-posting/`, data);
    return response;
  } catch (error) {
    console.error("Error creating new job-post:", error.message);
    return { error: true, message: error.message };
  }
};

// New DELETE API: Delete job post
export const deleteJobApi = async (jobpostId) => {
  try {
    const response = await commonApi("DELETE", `${serverUrl2}/job-posting/${jobpostId}/`, "");
    return response;
  } catch (error) {
    console.error("Error deleting job post:", error.message);
    return { error: true, message: error.message };
  }
};

// PATCH API: Update job posting
export const updateJobApi = async (jobId, updatedData) => {
  try {
    const response = await commonApi("PATCH", `${serverUrl2}/job-posting/${jobId}/`, updatedData);
    return response;
  } catch (error) {
    console.error("Error updating job post:", error.message);
    return { error: true, message: error.message };
  }
};

// GET job details by jobId
export const getJobDetailsApi = async (jobId) => {
  try {
    const response = await commonApi("GET",`${serverUrl2}/job-detail/${jobId}/`);
    return response
  } catch (error) {
    console.error("Error fetching job details:", error);
    return { error: true };
  }
};

// POST new job detail
export const addJobDetailApi = async (newDetail) => {
  try {
    const response = await commonApi("POST",`${serverUrl2}/job-detail/`,newDetail);
    return response;
  } catch (error) {
    console.error("Error adding job detail:", error);
    return { error: true };
  }
};

// PATCH job detail
export const updateJobDetailApi = async (detailId, updatedDetail) => {
  try {
    const response = await commonApi("PATCH",`${serverUrl2}/job-detail-detail/${detailId}/`,updatedDetail);;
    return response;
  } catch (error) {
    console.error("Error updating job detail:", error);
    return { error: true };
  }
};

// DELETE job detail
export const deleteJobDetailApi = async (detailId) => {
  try {
    const response = await commonApi("DELETE",`${serverUrl2}/job-detail-detail/${detailId}/`,);
    return response;
  } catch (error) {
    console.error("Error deleting job detail:", error);
    return { error: true };
  }
};


// GET job response by jobId
export const getJobResponsesApi = async (jobId) => {
  try {
    const response = await commonApi("GET",`${serverUrl2}/job-response/${jobId}/`);
    return response
  } catch (error) {
    console.error("Error fetching job response:", error);
    return { error: true };
  }
};


// DELETE job response
export const deleteJobResponseApi = async (detailId) => {
  try {
    const response = await commonApi("DELETE",`${serverUrl2}/job-response-detail/${detailId}/`,);
    return response;
  } catch (error) {
    console.error("Error deleting job response:", error);
    return { error: true };
  }
};


// PATCH job response
export const editJobResponseApi = async (detailId, updatedDetail) => {
  try {
    const response = await commonApi("PATCH",`${serverUrl2}/job-response-detail/${detailId}/`,updatedDetail);;
    return response;
  } catch (error) {
    console.error("Error updating job response:", error);
    return { error: true };
  }
};



// New GET API: fetching PlacementCount data
export const getPlacementCountDetailsapi = async () => {
  try {
  
    const response = await commonApi("GET", `${serverUrl2}/placement-count/`);
    return response; // Ensure the API response is returned correctly
  } catch (error) {
    console.error('Error fetching PlacementCount details:', error.message);
    throw error; // Propagate the error
  }
};

//edit PlacementCount page
export const editPlacementCountPage = async (id,formDataToSend) => {
  try {
    console.log("sending data",formDataToSend);
    
    const response = await commonApi("PATCH", `${serverUrl2}/placement-count-detail/${id}/`, formDataToSend);
    return response;
  } catch (error) {
    console.error("Error editig PlacementCount page data:", error.message);
    return { error: true, message: error.message };
  }
};


// post PlacementCount page
export const addPlacementCountApi = async (data) => {
  console.log("API request initiated", data); // Log the data
  try {
    const response = await commonApi("POST", `${serverUrl2}/placement-count/`, data);
    return response;
  } catch (error) {
    console.error("Error creating new placement count:", error.message);
    return { error: true, message: error.message };
  }
};


// New DELETE API: Delete PlacementCount Data
export const deletePlacementCountApi = async (id) => {
  try {
    const response = await commonApi("DELETE", `${serverUrl2}/placement-count-detail/${id}/`, "");
    return response;
  } catch (error) {
    console.error("Error deleting PlacementCount:", error.message);
    return { error: true, message: error.message };
  }
};







// New GET API: fetching PlacementProcess data
export const getPlacementProcessDetailsapi = async () => {
  try {
  
    const response = await commonApi("GET", `${serverUrl2}/placement-process/`);
    return response; // Ensure the API response is returned correctly
  } catch (error) {
    console.error('Error fetching PlacementProcess details:', error.message);
    throw error; // Propagate the error
  }
};


// post PlacementProcess page
export const addPlacementProcessApi = async (data) => {
  console.log("API request initiated", data); // Log the data
  try {
    const response = await commonApi("POST", `${serverUrl2}/placement-process/`, data);
    return response;
  } catch (error) {
    console.error("Error creating new PlacementProcess :", error.message);
    return { error: true, message: error.message };
  }
};


// Edit PlacementProcess page
export const editPlacementProcessPage = async (id, formDataToSend) => {
  try {
      console.log("sending data", formDataToSend);
      const response = await commonApi("PATCH", `${serverUrl2}/placement-process-detail/${id}/`, formDataToSend);
      return response;
  } catch (error) {
      console.error("Error editing PlacementProcess page data:", error.message);
      return { error: true, message: error.message };
  }
};

// Delete PlacementProcess Data
export const deletePlacementProcessApi = async (id) => {
  try {
      const response = await commonApi("DELETE", `${serverUrl2}/placement-process-detail/${id}/`, "");
      return response;
  } catch (error) {
      console.error("Error deleting PlacementProcess:", error.message);
      return { error: true, message: error.message };
  }
};





// New GET API: Fetch Testimonials Data
export const getTestimonialDataApi = async (page = 1) => {
  try {
    const response = await commonApi("GET", `${serverUrl2}/review/?page=${page}`, "");
    return response;
  } catch (error) {
    console.error("Error fetching Testimonials data:", error.message);
    return { error: true, message: error.message };
  }
};

// New PATCH API: Edit Testimonial Data
export const updateTestimonialApi = async (id, data) => {
  try {
    const response = await commonApi("PATCH", `${serverUrl2}/review/${id}/`, data);
    return response;
  } catch (error) {
    console.error("Error updating Testimonial data:", error.message);
    return { error: true, message: error.message };
  }
};

// New POST API: Create New Testimonial
export const addTestimonialApi = async (data) => {
  console.log("API request initiated", data); // Log the data
  try {
    const response = await commonApi("POST", `${serverUrl2}/review/`, data);
    return response;
  } catch (error) {
    console.error("Error creating new Testimonial:", error.message);
    return { error: true, message: error.message };
  }
};

// New DELETE API: Delete Testimonial Data
export const deleteTestimonialApi = async (id) => {
  try {
    const response = await commonApi("DELETE", `${serverUrl2}/review/${id}/`, "");
    return response;
  } catch (error) {
    console.error("Error deleting Testimonial:", error.message);
    return { error: true, message: error.message };
  }
};

// New GET API: Fetch Course tags Data
export const getCourseTagsApi = async () => {
  try {
    const response = await commonApi("GET", `${serverurl}/tags/`, "");
    return response;
  } catch (error) {
    console.error("Error fetching common-utils:", error.message);
    return { error: true, message: error.message };
  }
};

// New POST API: ADD course tags Data
export const addCourseTagApi = async (data) => {
  console.log("API request initiated", data); // Log the data
  try {
    const response = await commonApi("POST", `${serverurl}/tags/`, data);
    return response;
  } catch (error) {
    console.error("Error creating new Course tag:", error.message);
    return { error: true, message: error.message };
  }
};

// New DELETE API: Delete course tag Data
export const deleteCourseTagApi = async (courseTagId) => {
  try {
    const response = await commonApi("DELETE", `${serverurl}/tags/${courseTagId}/`, "");
    return response;
  } catch (error) {
    console.error("Error deleting Course Tag:", error.message);
    return { error: true, message: error.message };
  }
};

// New PATCH API: Edit course tag Data
export const updateCourseTagApi = async (courseTagId, data) => {
  try {
    const response = await commonApi("PATCH", `${serverurl}/tags/${courseTagId}/`, data);
    return response;
  } catch (error) {
    console.error("Error updating Course Tag data:", error.message);
    return { error: true, message: error.message };
  }
};

// New GET API: Fetch instaToken Data
export const getInstaTokenApi = async () => {
  try {
    const response = await commonApi("GET", `${serverUrl2}/instagram/`, "");
    return response;
  } catch (error) {
    console.error("Error fetching Insta Token:", error.message);
    return { error: true, message: error.message };
  }
};

// New PATCH API: Edit course tag Data
export const updateInstaTokenApi = async (instaId, data) => {
  try {
    const response = await commonApi("PATCH", `${serverUrl2}/instagram-detail/${instaId}/`, data);
    return response;
  } catch (error) {
    console.error("Error updating Insta Token:", error.message);
    return { error: true, message: error.message };
  }
};


// New GET API: Fetch Navbar content Data
export const getNavbarContent = async () => {
  try {
    const response = await commonApi("GET", `${serverurl}/navbar/`, "");
    return response;
  } catch (error) {
    console.error("Error fetching Navbar Content:", error.message);
    return { error: true, message: error.message };
  }
};


// New PATCH API: Edit navbar Data Data
export const updateNavbarContentApi = async (NavId, data) => {
  try {
    const response = await commonApi("PATCH", `${serverurl}/navbar/${NavId}/`, data);
    return response;
  } catch (error) {
    console.error("Error updating Navbar Content:", error.message);
    return { error: true, message: error.message };
  }
};



export const deleteNewBatchDateApi = async (id) => {
  try {
    const response = await commonApi("DELETE", `${serverurl}/course-batch/${id}/delete/`, "");
    return response;
  } catch (error) {
    console.error("Error deleting trainer:", error.message);
    return { error: true, message: error.message };
  }
};

export const getGiveAwayContent = async (page = 1, search = '', itemsPerPage = 10) => {
  try {
    const response = await commonApi(
      "GET", 
      `${serverurl}/giveaway/?page=${page}${search ? `&search=${search}` : ''}&page_size=${itemsPerPage}`, 
      ""
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching Giveaway Content:", error.message);
    return { error: true, message: error.message };
  }
};

// New GET API: Fetch Walkin content Data
export const getWalkin = async (queryParams = "") => {
  try {
    const url = queryParams ? `${serverurl}/walkins/?${queryParams}` : `${serverurl}/walkins/`;
    const response = await commonApi("GET", url, "");
    return response;
  } catch (error) {
    console.error("Error fetching Walkin Content:", error.message);
    return { error: true, message: error.message };
  }
};


// New GET API: Fetch Walkin by id content Data
export const getWalkinById = async (id) => {
  try {
    const response = await commonApi("GET", `${serverurl}/walkins/${id}/`, "");
    return response;
  } catch (error) {
    console.error("Error fetching Walkin Content:", error.message);
    return { error: true, message: error.message };
  }
};


export const getDashboard = async (queryParams = '') => {
  try {
    const response = await commonApi("GET", `${serverUrl2}/dashboard/${queryParams}`, "");
    return response;
  } catch (error) {
    console.error("Error fetching Dashboard:", error.message);
    return { error: true, message: error.message };
  }
};


export const getDashboardBrochure = async (queryParams = '') => {
  try {
    const response = await commonApi("GET", `${serverUrl2}/brochure-requests/by-date/${queryParams}`, "");
    return response;  
  }catch (error) {
    console.error("Error fetching Dashboard Brochure:", error.message);
    return { error: true, message: error.message };
  }
}


export const getDashboardContactFormSubmissions = async (queryParams = '') => {
  try{
    const response = await commonApi("GET", `${serverUrl2}/contact-us-data/by-date/${queryParams}`, "");
    return response; 
  }catch (error) {
    console.error("Error fetching Dashboard Contact Form Submissions:", error.message);
    return { error: true, message: error.message };
  }
}


export const getDashboardWalkin = async (queryParams = '') => {
  try{
    const response = await commonApi("GET", `${serverurl}/walkins/by-date/${queryParams}`, "");
    return response;  
  }catch (error) {
    console.error("Error fetching Dashboard Walkin:", error.message);
    return { error: true, message: error.message };
  }
}


export const getDashboardCallback = async (queryParams = '') => {
  try{
    const response = await commonApi("GET", `${serverUrl2}/book-callback/by-date/${queryParams}`, "");
    return response;  
  }catch (error) {
    console.error("Error fetching Dashboard Callback:", error.message);
    return { error: true, message: error.message };
  }
}